import React, { useEffect, useState } from "react";
import { FaFileExcel, FaSearch } from "react-icons/fa";
import { Form, InputGroup, Button, Badge, DropdownButton, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Table from "../../constants/Table";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import './quotation.css'
import * as XLSX from "xlsx";
import {
  STATUS_DROPDOWN,
  getStatusProps,
} from "../../constants/status";
import StatusBadge from "../../constants/statusBadge";

const QuotationsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Statuses");
    const [quotation, setQuotations] = useState([]);
    const [loading, setLoading] = useState(false);
    const userDetails = JSON.parse(localStorage.getItem("user_details"));
      const navigate = useNavigate();

  const getQuotationList = async () => {
    setLoading(true);
    try {
      let res = await apicall.get(`review_quotations/${userDetails?.company_profile_id}`);
      setQuotations(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };
   useEffect(() => {
      getQuotationList();
    }, []);

  const actionButton = () => (
    <Button variant="outline-danger" size="sm">View</Button>
  );



    const bookingHeaders = [
        'RFQ Number',
        "Created by",
        'Title',
        'Created Date',
        'Due Date',
         'Status',
        'Suppliers Invited',
        'Total Amount',    
    ];

const handleView = (index) => {
  const selectedRFQ = quotation[index];
  if (!selectedRFQ) return;

  navigate(`/quotationDetails/${selectedRFQ.id}`, {
    state: { rfq: selectedRFQ },
  });
};
const handleEdit = (rowIndex) => {
  const selectedRFQ = quotation[rowIndex];
  if (!selectedRFQ) return toast.error("RFQ not found");

  const normalizedRFQ = mapReviewQuotationToRFQ(selectedRFQ);

  navigate("/rfq", {
    state: {
      mode: "edit",
      formData: normalizedRFQ,
    },
  });
};
const mapReviewQuotationToRFQ = (q) => ({
  id: q.id,
  rfq_id: q.rfq_id,
  display_id: q.display_id,
  title: q.rfq_title,
  location: q.location,
  delivery_date: q.delivery_date,
  responsible_date: q.responsible_date,
  created: q.created,
  instructions: q.instructions,
  vendor_option: q.vendor_option,
  user: q.user,
  user_id: q.user_id,

  RFQ_Data: q.RFQ_Data || q.items || [],

  supplier_details: q.supplier_details || [],
  supplier_list: q.suppliers?.map(s => s.supplier_id) || [],

  rfq_status: q.rfq_status,
  status: 1,

documents: q.rfq_documents || null,
  rfq_required_documents: q.rfq_required_documents || [],
 delivery_params:
    typeof q.delivery_params === "string"
      ? q.delivery_params
      : null, params:q.params,
  orders_data: null,
});

const validRFQStatusLabels = STATUS_DROPDOWN.map((s) => s.toLowerCase());

const filteredData = quotation.filter((item) => {
  const searchLower = searchTerm.toLowerCase();

  const matchesSearch =
    `${item.rfq_id}`.toLowerCase().includes(searchLower) ||
    item.rfq_title.toLowerCase().includes(searchLower);

  const statusCode = Number(item.rfq_status);
  const statusLabel = getStatusProps(statusCode).label;

  const matchesStatus =
    statusFilter === "All Statuses" ||
    statusLabel.toLowerCase() === statusFilter.toLowerCase();

  return matchesSearch && matchesStatus;
});

const rfq_Data = filteredData.map(item => ({
  row: [
    item.display_id,
    item.first_name,
    item.rfq_title,
    new Date(item.created).toLocaleDateString(),
    new Date(item.responsible_date).toLocaleDateString(),
    <StatusBadge status={item.rfq_status} />,
    item.suppliers_sent,
    item.total_estimated_price,
  ],
  _meta: {
    rfq_status: item.rfq_status,
  },
}));





const clearAllFilters = () => {
  setStatusFilter("All Statuses");   
  setSearchTerm("");               
};
const handleExportExcel = () => {

  const excelData = filteredData.map((item) => ({
    "RFQ Number": item.display_id,
    "Created By": item.first_name,
    "Title": item.rfq_title,
    "Created Date": new Date(item.created).toLocaleDateString(),
    "Due Date": new Date(item.responsible_date).toLocaleDateString(),
    "Status": item.suppliers?.[0]?.status_name || "N/A",
    "Suppliers Invited": item.suppliers_sent,
    "Total Amount": item.total_estimated_price,
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Quotations");

  XLSX.writeFile(workbook, "Quotations_List.xlsx");
};

return (
 <div className="rfq-section">
      <div className="rfq-header">
    <h4>Quotations</h4>
  </div>

<div className="filters-container">

  {/* LEFT FILTERS */}
  <div className="filters-left">

    <div className="filter-search">
      <InputGroup className="custom-search">
        <InputGroup.Text>
          <FaSearch />
        </InputGroup.Text>
        <Form.Control
          type="search"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputGroup>
    </div>

    <div className="filter-status">
     <DropdownButton
  id="status-filter"
  variant="outline-secondary"
  title={statusFilter}
>
  <Dropdown.Item onClick={() => setStatusFilter("All Statuses")}>
    All Statuses
  </Dropdown.Item>
  {STATUS_DROPDOWN.map((status, index) => (
    <Dropdown.Item key={index} onClick={() => setStatusFilter(status)}>
      {status}
    </Dropdown.Item>
  ))}
</DropdownButton>

    </div>

    <div className="filter-clear">
      <button className="btn clear-btn" onClick={clearAllFilters}>
        Clear All
      </button>
    </div>

  </div>

  {/* RIGHT ACTIONS */}
  <div className="filters-right">
    <button
      className="btn clear-btn"
      onClick={() => navigate("/rfq", { state: { mode: "add" } })}
    >
      Create RFQ
    </button>
 <button
  className="btn export-btn" 
 title="Export to Excel"
  onClick={handleExportExcel}
 >
    <FaFileExcel size={18} style={{ marginRight: 6 ,color:'green'}} />
    
  </button>  </div>

</div>

<div className="rfq-table-scroll">
<Table
  headers={bookingHeaders}
  data={rfq_Data}
  pagination
  recordsCount={10}
  Action={{ edit: handleEdit, view: handleView }}
  actionType="edit-view"
/>

</div>


</div>

);

};

export default QuotationsPage;

